import axios from 'axios'

/**
 * 第二种请求接口的方法 --> @toUpdate
 * （暂定：因后台接口从c# 过渡到 java 所以接口暂时有2个IP，先写多一个request.js区分，后期再调整）
 */
// let BASE_URL = 'http://localhost:9253' // 请求ip（前缀）
// let BASE_URL = 'http://hyehr.hegii.com:9089' // 请求ip（前缀）
let BASE_URL = 'http://120.76.77.155:8055' // 请求ip（前缀）
// 测试域名是否能访问

/**
 * 二次封装 axios
 * params {_p | baseurl | showErrorMsg} 请求参数 | ip地址（前缀） | 自动报错
 */
export default (_p = {}, baseurl = '', showErrorMsg = true) => {
  return new Promise((resolve, reject) => {
    // 设置默认的请求参数
    const _d = {
      method: 'get',
      // url: '/api/file/UpLoadFIle',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      params: {} // !!!=== 注意: get请求参数用params | post请求参数用data ===!!!
    }
    let localurl = true // 是否后台接口
    // 动态配置baseurl
    if (!baseurl) {
      baseurl = BASE_URL
    } else {
      localurl = false
    }
    // 设置默认post请求的headers
    if (_p.method === 'post') {
      _d.headers = { 'Content-Type': 'application/json; charset=UTF-8' }

      // form-data 请求头需 特殊转换格式
      const _h = _p.headers
      if (_h) {
        const _ct = _h['Content-Type'] || ''
        if (_ct && _ct.includes('multipart/form-data')) {
          const formFile = new FormData()
          for (const k in _p.data) {
            formFile.append(k, _p.data[k])
          }
          _p.data = formFile
        }
      }
    }
    // 动态配置url
    const url = _p.url
    _p.url = baseurl + _p.url // 加上前缀
    // 合并参数
    const params = Object.assign(_d, _p)    
    return axios(params)
      .then(res => {
        let response = {}
        if (Array.isArray(res.data) && res.data.length === 1) {
          // 有时返回数组对象[{}]格式
          response = res.data[0]
        } else {
          // 有时返回对象 || 字符串
          response = res.data ? res.data : res
        }

        const api = params.url.split('/').pop()     

        // 数据处理
        if (Object.prototype.toString.call(response) === '[object Object]') {
          if (
            response.iserror === '0' ||
            response.iserror === undefined ||
            !showErrorMsg
          ) {
            resolve(response)
          } else {
            // Notify({
            //   type: 'danger',
            //   message: response.errormsg
            //     ? JSON.stringify(response.errormsg)
            //     : '数据处理异常，请及时联系管理员！'
            // })
            reject(response)
          }
        } else if (
          Object.prototype.toString.call(response) === '[object Array]'
        ) {
          resolve(response)
        } else if (typeof response === 'string') {
          resolve(response)
        } else {
          resolve(response)
        }
      })
      .catch(err => {
        const errorMsg = err.message
        // 异常处理
        if (window.navigator.onLine === false) {
          err.message = '当前网络已断开，请检查网络连接！'
        } else if (err && err.response) {
          switch (err.response.status) {
            case 400:
              err.message = '请求错误(400)'
              break
            case 401:
              err.message = '未授权，请重新登录(401)'
              break
            case 403:
              err.message = '拒绝访问(403)'
              break
            case 404:
              err.message = '请求出错(404)'
              break
            case 408:
              err.message = '请求超时(408)'
              break
            case 500:
              err.message = '服务器错误(500)'
              break
            case 501:
              err.message = '服务未实现(501)'
              break
            case 502:
              err.message = '网络错误(502)'
              break
            case 503:
              err.message = '服务不可用(503)'
              break
            case 504:
              err.message = '网络超时(504)'
              break
            case 505:
              err.message = 'HTTP版本不受支持(505)'
              break
            default:
              err.message = `连接出错(${err.response.status})!` // @todo -- 后台暂时没有统一返回
          }
        } else if (errorMsg) {
          err.message =
            errorMsg === 'Network Error'
              ? '网络连接异常，请检查连接！'
              : errorMsg
        } else {
          err.message = '连接服务器失败!'
        }
        if (showErrorMsg) {
          if (err.message) {
            // Notify({
            //   type: 'danger',
            //   message: err.message
            // })
          } // Message.error(err.message)
          else {
            // Notify({
            //   type: 'danger',
            //   message: JSON.stringify(err)
            // })
          } //Message.error(JSON.stringify(err))
        }
        console.error(`${params.url.split('/').pop()}=`, err)
        reject(err)
      })
  })
}
